function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function(key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import MonitorModule from "../monitor-module";
import BaseLoggingModule from "./BaseLoggingModule";
import { LogLevel } from "./types";
class LoggingModule extends BaseLoggingModule {
  init(config, sdkContext) {
    if (this._isInitialized) {
      return;
    }
    var _config_meta;
    this.meta = _object_spread({}, (_config_meta = config.meta) !== null && _config_meta !== void 0 ? _config_meta : {}, sdkContext);
    this.debug = !!(sdkContext === null || sdkContext === void 0 ? void 0 : sdkContext.debug);
    if (config.monitorModuleConfig) {
      this._monitorModule.init(config.monitorModuleConfig, sdkContext);
    }
    if (config.customLoggingModule && config.customLoggingModule instanceof BaseLoggingModule) {
      this._customLogger = config.customLoggingModule;
    } else {
      this.warn("[LoggingModule]: init - incorrect implementation of LoggingModule");
    }
  }
  sendDebugMessage(event) {
    if (this.debug) {
      const { level } = event;
      console[level](event.message, event);
      try {
        chrome.runtime.sendMessage(event);
      } catch (e) {
      }
    }
  }
  send(event) {
    var _this__customLogger;
    this.sendDebugMessage(event);
    if (typeof ((_this__customLogger = this._customLogger) === null || _this__customLogger === void 0 ? void 0 : _this__customLogger.send) === "function") {
      this._customLogger.send(event);
    }
  }
  getMeta() {
    return _object_spread({}, this.meta);
  }
  info(message, data) {
    this.send({
      message,
      level: LogLevel.INFO,
      meta: this.getMeta(),
      data
    });
  }
  warn(message, data) {
    this.send({
      message,
      level: LogLevel.WARN,
      meta: this.getMeta(),
      data
    });
  }
  error(message, data) {
    this.send({
      message,
      level: LogLevel.ERROR,
      meta: this.getMeta(),
      data
    });
  }
  destruct() {
    var _this__customLogger;
    if (typeof ((_this__customLogger = this._customLogger) === null || _this__customLogger === void 0 ? void 0 : _this__customLogger.destruct) === "function") {
      this._customLogger.destruct();
    }
    this._isInitialized = false;
  }
  reportCUJ(name, status, data) {
    this._monitorModule.reportCUJ(name, status, data);
  }
  constructor() {
    super();
    this._monitorModule = new MonitorModule();
    this._isInitialized = false;
    this.debug = false;
    if (!LoggingModule._instance) {
      LoggingModule._instance = this;
    }
    return LoggingModule._instance;
  }
}
var LoggingModule_default = new LoggingModule();
export {
  LoggingModule_default as default
};

//# sourceMappingURL=LoggingModule.js.map